import React from 'react'

class Received extends React.Component {
  render() {
    return (
      <svg data-testid="received-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
          <g fill="#000">
            <g>
              <g>
                <g>
                  <path
                    d="M17.375 8.75l2.475 3.3c.081.108.129.231.144.356L20 12.5v8H2v-8c0-.122.03-.244.09-.356l.06-.094 2.475-3.3h12.75zM5.5 14h-2v5h15v-5h-2v2.783h-11V14zm11.124-3.75H5.375L3.688 12.5H7v2.783h8V12.5h3.312l-1.688-2.25zM11 .75c.38 0 .693.282.743.648l.007.102v3.553l1.665-1.663c.266-.266.683-.29.976-.073l.085.073c.266.266.29.683.072.977l-.072.084-2.946 2.945-.07.06-.033.026-.1.059-.105.041-.098.023-.124.01c-.043 0-.084-.003-.125-.01l-.097-.023-.106-.042-.068-.037-.05-.035c-.033-.025-.06-.048-.084-.072L7.524 4.45c-.292-.293-.292-.768 0-1.061.267-.266.683-.29.977-.073l.084.073 1.665 1.665V1.5c0-.414.336-.75.75-.75z"
                    transform="translate(-340.000000, -599.000000) translate(328.000000, 508.000000) translate(12.000000, 88.000000) translate(0.000000, 3.000000)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default Received
